
export default class Note{
    constructor(title='', text=''){
        this.title = title;
        this.text = text;
        this.setUpdatedOn();
    }

    setUpdatedOn(){
        this.updatedOn = new Date();
    }

    setId(){
        this.id = new Date().getTime();
    }
}